import type React from 'react';
import { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Helmet } from '@xing-com/crate-helmet';
import {
  Layout,
  Illustration,
  Headline,
  BodyCopy,
} from '@xing-com/crate-login-layout';
import { useLoginTracking } from '@xing-com/crate-login-tracking';
import { useLoginAppUrl } from '@xing-com/crate-xinglet';

import { AdSection } from './ad-section';
import { LogoutImageIllustration } from './illustrations/illustration';
import { Styled } from './logout.styles';
import { timeToGreetingKey } from './utils';

export const Logout: React.FC = () => {
  const { trackPageView, trackNwtInteraction } = useLoginTracking();
  const { formatMessage } = useIntl();
  const loginUrl = useLoginAppUrl();

  useEffect(() => {
    trackPageView({
      page: 'logout',
      EventLogout: 1,
    });
    trackNwtInteraction({
      event: 'logged_out',
      page: 'logout',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Helmet>
        <title>{formatMessage({ id: 'LOGIN_LOGOUT_META_TITLE' })}</title>
      </Helmet>
      <Layout showSimpleHeader showFooter>
        <Styled.CenterContainer>
          <Illustration>
            <LogoutImageIllustration />
          </Illustration>

          <Headline as={'h1'} data-testid="login-logout-headline">
            <FormattedMessage id={timeToGreetingKey()} />
          </Headline>

          <BodyCopy>
            <FormattedMessage id="LOGIN_LOGOUT_COMEBACK_MESSAGE" />
          </BodyCopy>

          <Styled.Button
            to={loginUrl}
            variant="primary"
            data-testid="login-again-link"
          >
            <FormattedMessage id="LOGIN_LOGOUT_COMEBACK_CTA" />
          </Styled.Button>
        </Styled.CenterContainer>

        <AdSection />
      </Layout>
    </>
  );
};
